import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import styles from './EmailVerification.module.css';
import { useDocumentHead } from '../../hooks/useDocumentHead';

const EmailVerification = () => {
    useDocumentHead(
        'Verify Email Account | TopSpeaks',
        'Complete your TopSpeaks account verification to access AI-powered speaking tools and expert coaching services.',
        'noindex, follow'
    );
    
    const [status, setStatus] = useState('verifying');
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const verifyEmail = async () => {
            const params = new URLSearchParams(location.search);
            const token = params.get('token');
            if (!token) {
                setStatus('error');
                return;
            }

            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/api/auth/verify-email`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ token }),
                });
                // eslint-disable-next-line
                const data = await response.json();

                if (response.ok) {
                    setStatus('success');
                    setTimeout(() => {
                        navigate('/login');
                    }, 3000);
                } else {
                    setStatus('error');
                }
            } catch (error) {
                setStatus('error');
            }
        };

        verifyEmail();
    }, [navigate, location]);

    const renderContent = () => {
        switch (status) {
            case 'verifying':
                return (
                    <div className={styles.messageContainer}>
                        <div className={styles.spinner}></div>
                        <h2>Verifying Your Email</h2>
                        <p>Please wait while we authenticate your account...</p>
                    </div>
                );
            case 'success':
                return (
                    <div className={`${styles.messageContainer} ${styles.success}`}>
                        <div className={styles.icon}>✓</div>
                        <h2>Email Verified Successfully</h2>
                        <p>Your account has been verified. You will be redirected to login shortly.</p>
                    </div>
                );
            case 'error':
                return (
                    <div className={`${styles.messageContainer} ${styles.error}`}>
                        <div className={styles.icon}>!</div>
                        <h2>Verification Failed</h2>
                        <p>We were unable to verify your email address. The verification link may have expired or is invalid.</p>
                        <button onClick={() => navigate('/signup')} className={styles.button}>
                            Return to Sign Up
                        </button>
                    </div>
                );
            default:
                return null;
        }
    };

    return (
        <div className={styles.container}>
            <div className={styles.content}>
                <div className={styles.card}>
                    {renderContent()}
                </div>
            </div>
        </div>
    );
};

export default EmailVerification;